import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cms-stat",
  "use": "icon-cms-stat-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-cms-stat\"><polygon points=\"65.25 140.65 58.89 134.28 93.31 99.86 113.23 119.79 149.9 83.12 156.27 89.48 113.23 132.52 93.31 112.59 65.25 140.65\" /><polygon points=\"157.59 117 148.59 117 148.59 90.8 122.39 90.8 122.39 81.8 157.59 81.8 157.59 117\" /><path d=\"M183.44,183.44H36.56V36.56H183.44Zm-137.88-9H174.44V45.56H45.56Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol